import React, { Component } from "react";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import General from "../../utils/General";
import AuthManager from "../../utils/AuthManager";

import IconFilter from "./icons/toolbar/menu/Filter";
import IconAdjust from "./icons/toolbar/menu/Adjust";
import IconStraighten from "./icons/toolbar/menu/Straighten";
import IconCrop from "./icons/toolbar/menu/Crop";
import IconText from "./icons/toolbar/menu/Text";
import IconFrame from "./icons/toolbar/menu/Frame";
import IconRetouch from "./icons/toolbar/menu/Retouch";

import TabFilter from "./toolbar/Filter";
import TabAdjust from "./toolbar/Adjust";
import TabStraighten from "./toolbar/Straighten";
import TabCrop from "./toolbar/Crop";
import TabText from "./toolbar/Text";
import TabFrame from "./toolbar/Frame";
import TabRotate from "./toolbar/Rotate";
import TabRetouch from "./toolbar/Retouch";

const MENU = [
  {
    id: 0,
    icon: <IconFilter />,
    title: "Filter",
    key: "filter",
    show: true,
  },
  {
    id: 1,
    icon: <IconAdjust />,
    title: "Adjust",
    key: "adjust",
    show: true,
  },
  {
    id: 7,
    icon: <IconRetouch />,
    title: "Retouch",
    key: "retouch",
    show: false,
  },
  {
    id: 2,
    icon: <IconStraighten />,
    title: "Straighten",
    key: "straighten",
    show: true,
  },
  {
    id: 3,
    icon: <IconCrop />,
    title: "Crop",
    key: "crop",
    show: true,
  },
  {
    id: 4,
    icon: <IconText />,
    title: "Text",
    key: "text",
    show: true,
  },
  {
    id: 6,
    icon: <IconFrame />,
    title: "Frame",
    key: "frame",
  },
];

export default class ToolBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: MENU,
      activeTab: props.activeTab,
    };
    this.straightenRef = React.createRef(null);
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps;
  }

  onCropperChanged(cropper) {
    let { activeTab } = this.state;
    if (activeTab !== "straighten") {
      return;
    }
    this.straightenRef.onCropperChanged(cropper);
  }

  _renderMenu() {
    let { menu } = this.state;
    return (
      <Nav variant="" className="flex-nowrap" justify>
        {menu.map((item) => {
          let showRetouch =
            AuthManager.currentUser.subscription?.perks?.movie_maker_enabled;
          if (item?.show === false && !showRetouch) {
            return null;
          }
          return (
            <Nav.Item
              key={item.id}
              onClick={() => {
                this.props.onTabChanged(item.key);
                this.setState({ activeTab: item.key });
              }}
            >
              <Nav.Link eventKey={item.key}>
                {item.icon}
                <span>{item.title}</span>
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>
    );
  }

  _renderMenuContents() {
    let state = General.clone(this.props.state);
    let commonProps = {
      onStateUpdated: this.props.onStateUpdated,
      undoDisabled: this.props.undoDisabled,
      redoDisabled: this.props.redoDisabled,
      onRedoClicked: this.props.onRedoClicked,
      onUndoClicked: this.props.onUndoClicked,
    };

    return (
      <>
        <Tab.Pane eventKey="filter">
          <TabFilter
            image={state.image.thumbnail}
            filter={state.filter}
            onFilterUpdated={this.props.onFilterUpdated}
            undoDisabled={this.props.undoDisabled}
            redoDisabled={this.props.redoDisabled}
            onRedoClicked={this.props.onRedoClicked}
            onUndoClicked={this.props.onUndoClicked}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="adjust">
          <TabAdjust
            {...commonProps}
            filter={state.filter}
            adjustments={state.adjustments}
            onSettingsClicked={this.props.onFilterSettingsClicked}
            onHSLClicked={this.props.onHSLClicked}
            onFilterUpdated={this.props.onFilterUpdated}
            showHSL={this.props.showHSL}
            setShowHSL={this.props.setShowHSL}
            onUpdated={(adjustments) => {
              state.adjustments = adjustments;
              this.props.onStateUpdated(state);
            }}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="straighten">
          <TabStraighten
            ref={(straightenRef) => (this.straightenRef = straightenRef)}
            undoDisabled={this.props.undoDisabled}
            redoDisabled={this.props.redoDisabled}
            onRedoClicked={this.props.onRedoClicked}
            onUndoClicked={this.props.onUndoClicked}
            onApplyClicked={this.props.onApplyClicked}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="crop">
          <TabCrop
            onAspectRatioChanged={this.props.onAspectRatioChanged}
            aspectRatio={this.props.aspectRatio}
            undoDisabled={this.props.undoDisabled}
            redoDisabled={this.props.redoDisabled}
            onRedoClicked={this.props.onRedoClicked}
            onUndoClicked={this.props.onUndoClicked}
            onApplyClicked={this.props.onApplyClicked}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="text">
          <TabText
            text={state.text}
            onUpdated={this.props.onTextUpdated}
            undoDisabled={this.props.undoDisabled}
            redoDisabled={this.props.redoDisabled}
            onRedoClicked={this.props.onRedoClicked}
            onUndoClicked={this.props.onUndoClicked}
            selectedTextColor={this.props.selectedTextColor}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="frame">
          <TabFrame
            originalImage={state.image.original}
            frame={state.frame}
            onFrameUpdated={this.props.onFrameUpdated}
            undoDisabled={this.props.undoDisabled}
            redoDisabled={this.props.redoDisabled}
            onRedoClicked={this.props.onRedoClicked}
            onUndoClicked={this.props.onUndoClicked}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="retouch">
          <TabRetouch
            undoDisabled={this.props.undoDisabled}
            redoDisabled={this.props.redoDisabled}
            onRedoClicked={this.props.onRedoClicked}
            onUndoClicked={this.props.onUndoClicked}
          />
        </Tab.Pane>
      </>
    );
  }

  render() {
    return (
      <div className="tool-bar">
        <div className={`min-height tb-${this.state.activeTab}`}>
          <Tab.Container
            activeKey={this.state.activeTab}
            defaultActiveKey={this.state.activeTab}
            unmountOnExit={false}
          >
            <Tab.Content className="menu-contents">
              {this._renderMenuContents()}
            </Tab.Content>
            <div className="menu">{this._renderMenu()}</div>
          </Tab.Container>
        </div>
      </div>
    );
  }
}
